module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section03_05_beach-photo-7c48a6eaa73f262dc8a6d57fa78be002.jpg";